import Vue from 'vue';
import Vuex from 'vuex';
import dialog from './modules/dialog';
import common from './modules/common';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    dialog,
    common,
  },
});
